import { assign, createMachine } from '@monofront/xstate-v4';
import { ADDRESS_MODAL_TRANSITIONS } from './transitions';
import { ADDRESS_MODAL_STATES } from './states';
import {
  IAddressModalContext,
  IAddressModalEvents,
  IOpenAddressModalEvent,
} from './types';
import {
  ADDRESS_MODAL_EXTERNAL_ACTIONS,
  sendSubmitAddressFormToParent,
} from './actions';

export const ADDRESS_MODAL_MACHINE_ID = 'address-modal';

export const addressModalMachine = createMachine<
  IAddressModalContext,
  IAddressModalEvents
>({
  predictableActionArguments: true,
  id: ADDRESS_MODAL_MACHINE_ID,
  initial: ADDRESS_MODAL_STATES.CLOSED,
  schema: {
    context: {} as IAddressModalContext,
    events: {} as IAddressModalEvents,
  },
  context: {
    defaultAddress: undefined,
    update: false,
    isForBillingAddress: false,
  },
  states: {
    [ADDRESS_MODAL_STATES.CLOSED]: {
      on: {
        [ADDRESS_MODAL_TRANSITIONS.OPEN]: {
          target: ADDRESS_MODAL_STATES.OPEN,
          actions: assign<IAddressModalContext, IOpenAddressModalEvent>({
            defaultAddress: (_, event) => event.defaultAddress,
            update: (_, event) => event.update ?? Boolean(event.defaultAddress),
            isForBillingAddress: (_, event) => event.isForBillingAddress,
          }),
        },
      },
    },
    [ADDRESS_MODAL_STATES.OPEN]: {
      entry: [ADDRESS_MODAL_EXTERNAL_ACTIONS.trackOpenModal],
      exit: [ADDRESS_MODAL_EXTERNAL_ACTIONS.trackCloseModal],
      on: {
        [ADDRESS_MODAL_TRANSITIONS.CLOSE]: ADDRESS_MODAL_STATES.CLOSED,
        [ADDRESS_MODAL_TRANSITIONS.SUBMIT]: {
          target: ADDRESS_MODAL_STATES.CLOSED,
          actions: [sendSubmitAddressFormToParent],
        },
      },
    },
  },
});
